export type ReferenceFileType = 'pdf' | 'image' | 'eml'

export type EnabledReferenceFileTypes = {
  pdf: boolean
  image: boolean
  eml: boolean
}

const IMAGE_MIME_TYPES = new Set(['image/png', 'image/jpeg', 'image/jpg'])
const IMAGE_EXTENSIONS = new Set(['.png', '.jpg', '.jpeg'])

const getExtension = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot < 0) {
    return ''
  }
  return fileName.slice(lastDot).toLowerCase()
}

export const detectReferenceFileType = (
  file: File
): ReferenceFileType | null => {
  const mime = file.type.toLowerCase()
  const extension = getExtension(file.name)

  if (mime === 'application/pdf') {
    return 'pdf'
  }
  if (mime === 'message/rfc822' || mime === 'application/eml') {
    return 'eml'
  }
  if (IMAGE_MIME_TYPES.has(mime)) {
    return 'image'
  }

  if (extension === '.pdf') {
    return 'pdf'
  }
  if (extension === '.eml') {
    return 'eml'
  }
  if (IMAGE_EXTENSIONS.has(extension)) {
    return 'image'
  }

  return null
}

export const buildReferenceFileAccept = (
  enabled: EnabledReferenceFileTypes
): Record<string, string[]> => {
  const accept: Record<string, string[]> = {}

  if (enabled.pdf) {
    accept['application/pdf'] = ['.pdf']
  }
  if (enabled.eml) {
    accept['message/rfc822'] = ['.eml']
  }
  if (enabled.image) {
    accept['image/png'] = ['.png']
    accept['image/jpeg'] = ['.jpg', '.jpeg']
  }

  return accept
}

export const formatEnabledReferenceFileTypesLabel = (
  enabled: EnabledReferenceFileTypes
): string => {
  const parts: string[] = []

  if (enabled.pdf) {
    parts.push('PDF')
  }
  if (enabled.eml) {
    parts.push('EML')
  }
  if (enabled.image) {
    parts.push('JPG', 'PNG')
  }

  return parts.join(' · ')
}
